/**
 * Navigation Service Constants
 * Contains all constant definitions for navigation functionality
 */

/**
 * Base path for onboarding routes
 */
export const ONBOARDING_BASE_PATH = "/onboarding";
